import { render, staticRenderFns } from "./CompanyRegistry.vue?vue&type=template&id=6751d23a&scoped=true&"
import script from "./CompanyRegistry.vue?vue&type=script&lang=js&"
export * from "./CompanyRegistry.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRegistry.vue?vue&type=style&index=0&id=6751d23a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6751d23a",
  null
  
)

export default component.exports